    <div class="ib-box-info--flex u-mb-xmedium ib-box-info--equal-height__item">
        <div class="ib-box-info ib-box-info--type-bond">
            <div class="ib-box-info__wrapper">
                <h2 class="ib-box-info__title">{{ boxInfoModel.title | translate}}</h2>
                <div class="ib-box-info__container">
                    <p *ngIf="boxInfoModel.text" class="ib-box-info__text">
                        {{ boxInfoModel.text| translate}}
                    </p>
                    <a *ngIf="boxInfoModel.linkText" class="ib-link ib-box-info__text" href="#" title="{{ boxInfoModel.linkText | translate}}">
                        {{ boxInfoModel.linkText | translate}}
                    </a>
                </div>
            </div>
        </div>
    </div>